import { makeStyles } from "@material-ui/core";
import { blue, green } from "@material-ui/core/colors";
import whatsBackgroundDark from "../../../assets/wa-background-dark.png";
import whatsBackground from "../../../assets/wa-background.png";

export const useMessageListStyles = makeStyles((theme) => {
  const isDark = (theme.palette.type || theme.palette.mode) === "dark";

  return {
  messagesListWrapper: {
    overflow: "visible", // Alterado para permitir que FloatingMessageActions seja visível
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",
    minWidth: 300,
    minHeight: 200,
  },

  messagesList: {
    backgroundImage:
      theme.mode === "light"
        ? `url(${whatsBackground})`
        : `url(${whatsBackgroundDark})`,
    backgroundColor: theme.mode === "light" ? "transparent" : "#0b0b0d",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 30px 20px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 20px 100px 20px",
    },
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },

  currentTick: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "95%",
    backgroundColor: theme.palette.primary.main,
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "1px 5px 10px #b3b3b3",
  },

  currentTicktText: {
    color: theme.palette.primary,
    fontWeight: "bold",
    padding: 10,
    alignSelf: "center",
    borderRadius: "10px",
    marginLeft: "0px",
  },

  dragElement: {
    background: "rgba(255, 255, 255, 0.8)",
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 999999,
    textAlign: "center",
    fontSize: "3em",
    border: "5px dashed #333",
    color: "#333",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  circleLoading: {
    color: blue[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "fit-content",
    padding: "6px 12px",
    margin: "10px auto 6px",
    borderRadius: "16px",
    backgroundColor: isDark
      ? "rgba(255, 255, 255, 0.08)"
      : "rgba(0, 0, 0, 0.06)",
    boxShadow: isDark
      ? "0 1px 2px rgba(0, 0, 0, 0.5)"
      : "0 1px 2px rgba(0, 0, 0, 0.15)",
  },

  dailyTimestampText: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    letterSpacing: 0.2,
    fontSize: 12,
    padding: 0,
    margin: 0,
  },

  floatingDayLabel: {
    position: "sticky",
    top: 8,
    display: "flex",
    justifyContent: "center",
    zIndex: 6,
    pointerEvents: "none",
  },

  messageCenter: {
    marginTop: 5,
    alignItems: "center",
    verticalAlign: "center",
    alignContent: "center",
    backgroundColor: "#E1F5FEEB",
    fontSize: "12px",
    minWidth: 100,
    maxWidth: 270,
    color: "#272727",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    //boxShadow: "0 1px 1px #b3b3b3",
  },
  deletedMessage: {
    color: "#f55d65",
  },
};
});
